module.exports = __webpack_public_path__ + "Roboto-Light.a2b8c641546c0e5a95e2.ttf";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-Light.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Light.ttf
// module chunks = 34